import { useCallback } from 'react';
import { useHistory, useParams } from 'react-router';
import { Col, Row } from 'reactstrap';

import GoBackButton from '../../components/Button/GoBackButton';
import { PathsLayouts } from '../../config/routes';
import CreateEvaluationGradeEntryBaseLoader from './Loaders/CreateEvaluationGradeEntryBaseLoader';
import CreateEvaluationGradeEntryForm from './parts/CreateEvaluationGradeEntryForm';
import CreateEvaluationGradeEntryInfoTags from './parts/CreateEvaluationGradeEntryInfoTags';
import { CreateEvaluationFormContextProvider } from './parts/EvaluationForm/context/CreateEvaluationFormContext';
import CreateEvaluationGradeEntryHeader from './parts/Header';
import { Button, Icon, Modal } from '@octano/global-ui';

export default function GradeEntryCreateEvaluation() {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const backToListGradeList = useCallback(() => {
    history.push(`${PathsLayouts.gradeEntry}`);
  }, [history]);

  return (
    <CreateEvaluationGradeEntryBaseLoader>
      {({ data, refresh }) => (
        <CreateEvaluationFormContextProvider
          gradesConfig={{
            finalGrade: data.gradesConfig.finalGrade ?? {},
            testGrades: data.gradesConfig.testGrades ?? [],
          }}
        >
          <div className="m-3 py-4 px-3 bg-white rounded">
            <Row className="mb-4">
              <Col className="mb-4">
                <GoBackButton onClick={backToListGradeList} />
              </Col>
              <Col md={6}>
                <CreateEvaluationGradeEntryInfoTags data={data.sectionData} />
              </Col>
            </Row>
            {!data.sectionData.StructureTypeSchema_id && (
              <Modal toggle={() => null} isOpen size="md">
                <div className="d-flex flex-column align-items-center text-center">
                  <Icon name="warning" size={45} />
                  <h1 className="text-dark fs-20 mt-3 mb-4">ATENCIÓN</h1>
                  <p className="fs-16 mb-5">
                    No se ha configurado una estructura de evaluación para el
                    nivel académico:{' '}
                    <b>{data.sectionData.AcademicLevel_name}</b> con la
                    modalidad: <b>{data.sectionData.Modality_name}</b>. Debe
                    contactar al administrador para configurar la estructura de
                    evaluación.
                  </p>
                  <Button
                    text="volver"
                    size="md"
                    onClick={() => history.push(`${PathsLayouts.gradeEntry}`)}
                    fullwidth
                  />
                </div>
              </Modal>
            )}
            <CreateEvaluationGradeEntryHeader />
            <CreateEvaluationGradeEntryForm sectionId={id} refresh={refresh} />
          </div>
        </CreateEvaluationFormContextProvider>
      )}
    </CreateEvaluationGradeEntryBaseLoader>
  );
}
